import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class WorkspaceProjectModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (WorkspaceProjectModel._instance == null) WorkspaceProjectModel._instance = new WorkspaceProjectModel(authManager);
        return WorkspaceProjectModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'projects/workspace-projects');

        this.entityName = 'projects.WorkspaceProject';
        this.privileges = {
            create: [["adminWorkspace"],["manageWorkspace"]],
            read: [["adminWorkspace"],["manageWorkspace"],["editWorkspace"],["readWorkspace"]],
            update: [["adminWorkspace"],["manageWorkspace"],["editWorkspace"]],
            delete: [["adminWorkspace"],["manageWorkspace"]],
        };

        this.label = 'Workspace Project';
        this.setLabel = 'Workspace Projects';

        this.browser = {
            name: 'default-projects-workspaceproject-browser',
            moduleName: 'default-projects-workspaceproject-browser',
            moduleTitle: 'Workspace Projects',
            moduleStateSlotName: 'default-projects-workspaceproject-browser',
        };

        this.editor = {
            name: 'default-projects-workspaceproject-editor',
            moduleName: 'default-projects-workspaceproject-editor',
            moduleTitle: 'Workspace Project',
            moduleStateSlotName: 'default-projects-workspaceproject-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'workspaceId',
                type: 'Workspace',
                persistent: true,
                label: 'Workspace',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'workspaceLabel',
                type: 'text',
                persistent: false,
                label: 'Workspace',
                distinctLabel: 'Workspace (Text)',
                readOnly: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'projectId',
                type: 'Project',
                persistent: true,
                label: 'Project',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'projectLabel',
                type: 'text',
                persistent: false,
                label: 'Project',
                distinctLabel: 'Project (Text)',
                readOnly: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'userId',
                type: 'User',
                persistent: true,
                label: 'User',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'userLabel',
                type: 'text',
                persistent: false,
                label: 'User',
                distinctLabel: 'User (Text)',
                readOnly: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'userRoleId',
                type: 'WorkspaceRole',
                persistent: true,
                label: 'User Role',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'userRoleLabel',
                type: 'text',
                persistent: false,
                label: 'User Role',
                distinctLabel: 'User Role (Text)',
                readOnly: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'userRoleCode',
                type: 'text',
                persistent: false,
                label: 'User Role Code',
                readOnly: true,
            },
        ];

    }

}
